// extracted by mini-css-extract-plugin
export default {"wrap_1000w":"index_wrap_1000w_9J1dl clearfix","left_640w":"index_left_640w_uF1Uu","right_300w":"index_right_300w_QmiJz"};